/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from "react";
import { useLocalStorage } from "usehooks-ts"

export type Deliverable = {
    id: string;
    deliverableName: string;
    videoType: string;
    lengthRange: string;
    notes: string;
    aspectRatio: string;
    resolution: string;
    frameRate: string;
    deliveryFormat: string;
    maxFileSize: string;
}

interface ProjectFormState {
    projectName: string;
    brief: string;
    dueDate: string;
    deliverables: Deliverable[];
    currentStep: number;
}

interface CreateProjectContextType {
    formState: ProjectFormState;
    setFormState: React.Dispatch<React.SetStateAction<ProjectFormState>>;
    resetForm: () => void;
}

const defaultFormState: ProjectFormState = {
    projectName: "",
    brief: "",
    dueDate: "",
    deliverables: [],
    currentStep: 1
};

const CreateProjectContext = createContext<CreateProjectContextType | null >(null);

export function CreateProjectProvider({ children }: { children: React.ReactNode }) {
    const [ formState, setFormState ] = useLocalStorage<ProjectFormState>("createProjectFormState", defaultFormState);
    function resetForm() {
        setFormState(defaultFormState);
    }

    return (
        <CreateProjectContext.Provider value={{ formState, setFormState, resetForm }}>
            {children}
        </CreateProjectContext.Provider>
    )
}

export function useCreateProject() {
    const context = useContext(CreateProjectContext);
    if (!context) {
        throw new Error("useCreateProject must be used within a CreateProjectProvider");
    }
    return context;
}